import React from 'react'

export const TopBar = () => {
  return (
    <div className="topbar">
      <div className="signicat-logo"></div>
    </div>
  )
}
